<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout justify-center row>
    <v-dialog
        :item="item"
        :value="value"
        @input="close()"
        v-model="show"
        width="800">
      <v-card>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">{{ getTitleText() }}</v-list-item-title>
            <v-list-item-subtitle v-if="item">
              {{ getSubtitleText(item) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-layout>
          <v-flex>
            <v-text-field
                clearable
                class="ps-3 pe-3"
                label="Link zu Hilfevideo"
                outline
                v-model="demoVideo"
                :rules="rules"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-file-input
                v-model="demoFile"
                class="ps-2 pe-3"
                :accept="'application/pdf'"
                color="primary"
                label="Hilfs-PDF"
                outlined
                prepend-icon="mdi-upload">

              <template v-slot:selection="{ index, text }">
                <v-chip
                    v-if="index < 2"
                    color="primary"
                    dark
                    label
                    small>
                  {{ text }}
                </v-chip>
              </template>

            </v-file-input>
          </v-flex>
        </v-layout>

        <v-text-field
            class="ps-3 pe-3"
            label="Ordnername"
            v-model="state.name"
        ></v-text-field>

        <v-layout>
          <v-flex>
            <v-text-field
                clearable
                class="ps-3 pe-3"
                label="Sortierungsposition"
                outline
                required
                type="number"
                min=0
                v-model="order_index"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-select
                v-if="!state.isEdit"
                :items="state.items"
                class="ps-3 pe-3"
                label="Ordnertyp"
                required
                v-model="state.select"
            ></v-select>

            <!-- -->
            <v-card-text v-if="state.isEdit && this.state.folder.demo_pdf_url && this.state.folder.demo_pdf_url !== ''"
                         class="ms-0 ps-0 primary--text font-weight-bold text-decoration-underline"
                         style="cursor: pointer"
                         @click.stop="openHelpPdf">
              Hilfs-PDF öffnen
            </v-card-text>
          </v-flex>
        </v-layout>

        <v-file-input
            accept="application/pdf"
            class="ps-2 pe-3"
            color="deep-purple accent-4"
            counter
            id="folder_file_input"
            label="Upload"
            multiple
            outlined
            placeholder="Fügen sie eine PDF hinzu"
            prepend-icon="mdi-upload"
            v-if="offersFileUpload"
            v-model="state.files">

          <template v-slot:selection="{ index, text }">
            <v-chip
                color="deep-purple accent-4"
                dark
                label
                small
                v-if="index < 1">
              {{ text }}
            </v-chip>

            <span class="overline grey--text text--darken-3 mx-2" v-else-if="index === 2">
                            +{{ state.files.length - 2 }} Datei(en)
                        </span>

          </template>

        </v-file-input>

        <v-card-actions class="pe-3">
          <v-spacer></v-spacer>
          <v-btn
              @click="show = false"
              color="primary">Abbrechen
          </v-btn>

          <v-btn
              v-if="!state.isEdit"
              @click="addFolder"
              color="primary">Hinzufügen
          </v-btn>

          <v-btn
              v-if="state.isEdit"
              @click="editFolder"
              color="primary">Übernehmen
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {FolderType} from "@/ts/enums/FolderType";
import FolderDialogStore from "@/ts/stores/FolderDialogStore";
import {FolderTypeApi} from "@/ts/enums/FolderTypeApi";

export default {
  name: "FolderDialog",

  data() {
    return {
      rules: [
        v => /(https:\/\/[^\s]+)/.test(v) || 'Keine gültige URL. Format: https://<...>'
      ],
      state: FolderDialogStore.state,
      order_index: FolderDialogStore.state.order_index,
      demoVideo: FolderDialogStore.state.demoVideoUrl,
      demoFile: [],
      show: false
    }
  },
  props: {
    value: Boolean,
    item: {}
  },
  watch: {
    state: {
      handler() {
        this.show = this.state.dialogVisible;
      },
      deep: true
    },
    show(val) {
      this.order_index = this.state.order_index;

      if (this.state.isEdit) {
        this.demoVideo = this.state.demoVideoUrl
      }

      if (!val) {
        this.close()
      }
    }
  },
  computed: {
    offersFileUpload() {
      let result = false

      // Ignore IDE suggestion to remove cases
      switch (this.state.select) {
        case FolderType.FORMULAR:
        case FolderType.LEISTUNG:
        case FolderType.LEISTUNG_OHNE_PREISE:
        case FolderType.DOCUMENTATION:
          result = true
          break;
      }
      return result
    }
  },
  methods: {
    close() {
      this.order_index = 0
      this.demoVideo = ""
      this.demoFile = []
      FolderDialogStore.dismiss()
    },
    addFolder() {
      const addData = {
        'files': FolderDialogStore.state.files,
        'name': FolderDialogStore.state.name,
        'order_index': Number(this.order_index),
        'folder_type': this.getApiStringForFolderType(FolderDialogStore.state.select),
        'demo_video_url': this.demoVideo,
      }

      const doesUpdateDemoPdf = (this.demoFile && typeof this.demoFile === "object" && 'name' in this.demoFile);

      // console.log('DEBUG 1', this.demoFile)
      // console.log('DEBUG 2', doesUpdateDemoPdf)
      // console.log('DEBUG 3', FolderDialogStore.state.select)
      // console.log('DEBUG 4', this.getApiStringForFolderType(FolderDialogStore.state.select))

      if (doesUpdateDemoPdf) {
        addData['demo_pdf_file'] = this.demoFile
      }
      this.$emit('add', addData);
    },
    editFolder() {
      const editData = {
        'id': FolderDialogStore.state.folder.id,
        'name': FolderDialogStore.state.name,
        'order_index': Number(this.order_index),
        'folder_type': this.getApiStringForFolderType(FolderDialogStore.state.select),
        'demo_video_url': this.demoVideo,
      }

      const doesUpdateDemoPdf = (this.demoFile && typeof this.demoFile === "object" && 'name' in this.demoFile);

      if (doesUpdateDemoPdf) {
        editData['demo_pdf_file'] = this.demoFile
      }

      this.$emit('edit', editData);
    },
    getApiStringForFolderType(selectedObject) {
      switch (selectedObject) {
        case FolderType.PARENT:
          return FolderTypeApi.PARENT;
        case FolderType.FORMULAR:
          return FolderTypeApi.FORMULAR;
        case FolderType.LEISTUNG:
          return FolderTypeApi.LEISTUNG;
        case FolderType.LEISTUNG_OHNE_PREISE:
          return FolderTypeApi.LEISTUNG_OHNE_PREISE;
        case FolderType.IMAGE:
          return FolderTypeApi.IMAGE;
        case FolderType.FREE:
          return FolderTypeApi.FREE;
        case FolderType.DOCUMENTATION:
          return FolderTypeApi.DOCUMENTATION;
      }
    },
    getTitleText() {
      return FolderDialogStore.state.isEdit ? 'Ordner editieren' : 'Ordner hinzufügen'
    },
    getSubtitleText(item) {
      return FolderDialogStore.state.isEdit ? `Geben sie einen Ordnernamen an. Sie inserieren in Ordner ‎${item.name}.` : `Geben sie einen Ordnernamen an und wählen sie den Ordnertyp aus. Sie inserieren in Ordner ‎${item.name}.`
    },
    openHelpPdf() {
      window.open(this.state.folder.demo_pdf_url)
    }
  }
}
</script>
